/**
 * 소형 주차별 추이 막대.
 *
 * 카드의 큰 추이(BriefingCard.TrendBars)와 같은 규칙을 좁은 자리에서 씁니다 —
 * 최근 3주는 강조색, 이전 5주는 회색. 규칙이 자리마다 다르면 같은 회원의
 * 추이가 목록과 팝업에서 다르게 읽힙니다.
 *
 * 값이 0 인 주도 **막대를 그립니다**(최소 높이 3px). 아예 안 그리면
 * "그 주는 기록이 없다"처럼 보이는데, 실제로는 "그 주에 수업이 없었다"입니다.
 */

type Props = {
    /** 주차별 값 (오래된 주 → 최근 주) */
    data: number[];
    color: string;
    width?: number;
    height?: number;
};

const MiniTrendBars = ({ data, color, width = 96, height = 30 }: Props) => {
    /* max 를 0 으로 두면 나눗셈이 NaN 이 되어 막대가 사라진다 */
    const max = Math.max(...data, 1);
    return (
        <div className="flex items-end" style={{ height, gap: 3, width }} aria-hidden="true">
            {data.map((v, i) => {
                const recent = i >= data.length - 3;
                return (
                    <div
                        key={i}
                        style={{
                            flex: 1,
                            height: Math.max((v / max) * height, 3),
                            borderRadius: 2,
                            background: recent ? color : '#DDE5F0',
                        }}
                    />
                );
            })}
        </div>
    );
};

export default MiniTrendBars;
